export const usaRegionKY = "KY";
export const usaRegionCA = "CA";
export const usaRegionBC = "BC";
export const usaRegionPC = "PC";
export const usaRegionPK = "PK";
export const usaRegionBC2023 = "BC2023";

export const UKRegions = {
  Aintree: "AI",
  England: "EN",
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/models/Regions.ts